const PlanSection = () => null;

export default PlanSection;
